<div class="top-nav">
  <img class="user-avatar mx-3" [src]="user?.avatar" onerror="src='../../assets/Avatars/avatar-placeholder.png'" />
  <div class="clinic-logo"><img [src]="clinic?.logoUrl" onerror="src='../../assets/svg/emily-logo-final.svg'" /></div>
  <button class="btn em-btn btn-clean p-3" mat-button [matMenuTriggerFor]="ellipsisMenu" [disableRipple]="true">
    <i class="fal fa-ellipsis-v"></i>
  </button>
  <mat-menu #ellipsisMenu="matMenu" class="mr-1">
    <button mat-menu-item routerLink="schedule" routerLinkActive="active">Schedule</button>
    <button mat-menu-item routerLink="reports" routerLinkActive="active">Reports</button>
    <button mat-menu-item routerLink="patients-list" routerLinkActive="active">Patients</button>
    <button mat-menu-item *ngIf="companyClinics.length > 1" (click)="changeClinic()">
      <i class="far fa-house-chimney-medical fa-lg mr-2"></i>Change Clinic
    </button>
    <button mat-menu-item (click)="logout()"><i class="far fa-right-from-bracket fa-lg mr-2"></i>Logout</button>
  </mat-menu>
</div>

<div class="content">
  <router-outlet (activate)="onOutletActivate($event)"></router-outlet>
  <div *ngIf="displayCalendar" class="cal-overlay">
    <mat-calendar [selected]="currentDate" (selectedChange)="setSelectedDate($event)"></mat-calendar>
  </div>
</div>

<div *ngIf="isScheduleActive" class="bottom-nav">
  <div class="date-controls-group ml-3">
    <button class="btn em-btn btn-clean" (click)="goBackOneDay()">
      <i class="fal fa-chevron-left large-icon"></i>
    </button>
    <button class="btn em-btn btn-clean today" (click)="goToToday()">Today</button>
    <button class="btn em-btn btn-clean" (click)="goForwardOneDay()">
      <i class="fal fa-chevron-right large-icon"></i>
    </button>
  </div>
  <span class="ml-3">{{ currentDate | date : 'EEE, MMM d, YY' }}</span>
  <button class="btn em-btn btn-clean ml-auto mr-2" (click)="openCalendar($event)">
    <i class="fal fa-calendar-alt large-icon"></i>
  </button>
</div>

<ng-template #changeClinicModal>
  <h1 mat-dialog-title>Change Clinic</h1>
  <div mat-dialog-content>
    <app-select-clinic></app-select-clinic>
  </div>
  <div mat-dialog-actions [align]="'center'">
    <button mat-button class="btn em-btn em-btn-green" (click)="dialogRef.close()">Cancel</button>
  </div>
</ng-template>
